import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues10, KeyValues20, LocalService, PricingManagementWrapper, SummaryType, TriggeredEvent } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { SellerManagementService } from '../../../service/seller-management.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  id: string; summaryType: SummaryType; lstSectionConfigKeys: string[] = ["summary", "local_locations"]; item: KeyValues20; isLoadPayaments = false; isLoadWorkingHours = false; ctryCode: string = ''; content = ''; contentLanguageId = ''; pricingDetails: PricingManagementWrapper[];
  workingHours: KeyValues10; maxBodyHeight = 0; isShowProductBarCode = false; isShowProductPricing = false;
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private configurationManagementService: ConfigurationManagementService, private sellerManagementService: SellerManagementService, private router: Router, private productManagementService: ProductManagementService) { }

  ngOnInit(): void {
    switch (this.summaryType) {
      case SummaryType.User:
      case SummaryType.ServiceProvider: {
        this.lstSectionConfigKeys.push('create_account');
      } break;
      case SummaryType.Business: {
        this.lstSectionConfigKeys.push('seller');
      } break;
      case SummaryType.Guide: {
        this.lstSectionConfigKeys.push('guide');
      } break;
      case SummaryType.Product: {
        this.lstSectionConfigKeys.push('product_config');
      } break;
    }
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    switch (this.summaryType) {
      case SummaryType.Guide: {
        this.configurationManagementService.getGuideContent(1, parseInt(this.id)).subscribe(result => {
          this.content = result.value;
          this.contentLanguageId = result.key;
        });
      } break;
      default: {
        this.configurationManagementService.getSummary(this.id, this.summaryType, this.ctryCode).subscribe(result => {
          this.item = result;
        });
      } break;
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  getLanguageCodeName(name: string, isCode: boolean) {
    let names = name.split('&split');
    return isCode ? names[0] : names[1];
  }

  onAction(index, type = null) {
    switch (index) {
      case 1: {
        this.isLoadPayaments = true;
      } break;
      case 2: {
        this.isLoadWorkingHours = true;
        this.sellerManagementService.getWorkingRange(this.id, type).subscribe(result => {
          this.workingHours = result;
        });
      } break;
      case 3: {
        this.router.navigate(['/guide/1', this.id]);
        this.onPopupClose();
      } break;
      case 4: {
        this.isShowProductBarCode = true;
      } break;
      case 5: {
        this.isShowProductPricing = true;
        this.productManagementService.getPricingManagment(type, this.id, '').subscribe(result => {
          this.pricingDetails = result.pricings;
        });
      } break;
    }
  }
}
